<script lang="ts" setup>
import { useProjectOrganisationsLogic } from './logic/useProjectOrganisationsLogic';
import ProjectOrganisationCesgData from './sub-components/project-organisation-cesg/data/ProjectOrganisationCesgData.vue';
import ProjectOrganisationExternalData from './sub-components/project-organisation-external/data/ProjectOrganisationExternalData.vue';

import type {
  ProjectOrganisationsActionEvent,
  ProjectOrganisationsProps,
} from './types';

const props = defineProps<ProjectOrganisationsProps>();
const emit = defineEmits<{
  action: [event: ProjectOrganisationsActionEvent];
}>();

const { state, action } = useProjectOrganisationsLogic(props, (event) =>
  emit('action', event),
);
</script>

<template>
  <div class="organisations-grid">
    <ProjectOrganisationCesgData
      v-if="state.organisations.cesg"
      v-bind="state.organisations.cesg"
      @action="action.onAction"
    />
    <ProjectOrganisationExternalData
      v-for="org in state.organisations.external"
      :key="org.id"
      v-bind="org"
      @action="action.onAction"
    />
  </div>
</template>

<style scoped>
.organisations-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  align-content: start;
  align-items: start;
}

@media (max-width: 768px) {
  .organisations-grid {
    grid-template-columns: 1fr;
  }
}

</style>
